import { jsx, jsxs } from 'react/jsx-runtime';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { styled, css } from 'styled-components';
import { useQueryRevenueCatOffering } from '@fabric-app/compat/capabilities/pricing';
import { Spinner } from '@fabric-app/ui/components/Spinner';
import { formatPercentage, formatCurrency } from '@fabric-app/utils/number';
import { mediaMobile, mediaHover } from '@fabric-app/ui/constants/styled-utils';
import { useRunOnce } from '@fabric-app/hooks/useRunOnce';

const formatOfferingPrice = (value, code) => {
  return formatCurrency(value, code, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });
};
const SelectPackage = ({ upsellPlan, currentPlan, onSelect, selectedPackage }) => {
  const { data: offering, isLoading: isLoadingOffering } = useQueryRevenueCatOffering(upsellPlan.prices.revenueCatOfferingId);
  const { data: currentOffering, isLoading: isLoadingCurrentOffering } = useQueryRevenueCatOffering(currentPlan.prices.revenueCatOfferingId);
  useRunOnce(() => {
    if (offering?.annual) {
      onSelect(offering.annual);
    }
  }, {
    condition: !!offering && !!offering.annual
  });
  if (isLoadingOffering || isLoadingCurrentOffering || !offering) {
    return /* @__PURE__ */ jsx(Spinner, {
      size: 16
    });
  }
  const offeringAnnualDiscount = offering && offering.annual && offering.monthly ? 1 - offering.monthly.product.pricePerYear / offering.annual.product.pricePerYear : 0;
  return /* @__PURE__ */ jsxs(ItemsContainer, {
    children: [
      offering.monthly && /* @__PURE__ */ jsx(PackageButton, {
        isSelected: selectedPackage?.identifier === offering.monthly.identifier,
        onClick: () => onSelect(offering.monthly),
        children: /* @__PURE__ */ jsxs("div", {
          children: [
            /* @__PURE__ */ jsx(Title, {
              children: "Monthly"
            }),
            /* @__PURE__ */ jsx(Price, {
              children: currentOffering && currentOffering.monthly ? `+${formatOfferingPrice(offering.monthly.product.price - currentOffering.monthly.product.price, offering.monthly.product.currencyCode)}` : formatOfferingPrice(offering.monthly.product.price, offering.monthly.product.currencyCode)
            })
          ]
        })
      }),
      offering.annual && /* @__PURE__ */ jsxs(PackageButton, {
        isSelected: selectedPackage?.identifier === offering.annual.identifier,
        onClick: () => onSelect(offering.annual),
        children: [
          /* @__PURE__ */ jsxs("div", {
            children: [
              /* @__PURE__ */ jsx(Title, {
                children: "Annual"
              }),
              /* @__PURE__ */ jsx(Price, {
                children: currentOffering?.annual && currentOffering.annual ? `+${formatOfferingPrice(offering.annual.product.price - currentOffering.annual.product.price, offering.annual.product.currencyCode)}` : formatOfferingPrice(offering.annual.product.price, offering.annual.product.currencyCode)
              })
            ]
          }),
          offeringAnnualDiscount && offeringAnnualDiscount > 9e-3 && /* @__PURE__ */ jsx(DiscountBadge, {
            children: formatPercentage(offeringAnnualDiscount, {
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            })
          })
        ]
      })
    ]
  });
};
const PackageButton = styled.button.withConfig({
  displayName: "SelectPackage__PackageButton",
  componentId: "sc-8a6315d3-0"
})([
  `background:rgba(`,
  `,0.04);border-radius:10px;padding:0.75rem;height:60px;display:flex;align-items:flex-start;justify-content:space-between;gap:0.5rem;box-shadow:inset 0 0 0 1px rgba(`,
  `,0.8);text-align:left;transition:box-shadow 0.1s ease-in-out;`,
  `{flex-grow:1;flex-basis:100px;}`,
  `{&:hover{background:rgba(`,
  `,0.06);}}`,
  ``
], cssVar["color-bg-primary-reverse-rgb"], cssVar["color-border-primary-rgb"], mediaMobile, mediaHover, cssVar["color-bg-primary-reverse-rgb"], ({ isSelected }) => isSelected && css([
  `box-shadow:inset 0 0 0 2px `,
  `;`
], cssVar["color-bg-primary-reverse"]));
const Price = styled.div.withConfig({
  displayName: "SelectPackage__Price",
  componentId: "sc-8a6315d3-1"
})([
  `font-size:15px;font-weight:500;color:`,
  `;line-height:20px;text-align:left;`
], cssVar["color-text-tertiary"]);
const Title = styled.div.withConfig({
  displayName: "SelectPackage__Title",
  componentId: "sc-8a6315d3-2"
})([
  `font-size:15px;font-weight:600;color:`,
  `;line-height:20px;text-align:left;`
], cssVar["color-text-primary"]);
const ItemsContainer = styled.div.withConfig({
  displayName: "SelectPackage__ItemsContainer",
  componentId: "sc-8a6315d3-3"
})([
  `width:100%;display:flex;flex-direction:column;gap:0.5rem;`,
  `{flex-direction:row;}`
], mediaMobile);
const DiscountBadge = styled.div.withConfig({
  displayName: "SelectPackage__DiscountBadge",
  componentId: "sc-8a6315d3-4"
})([
  `background:`,
  `;color:`,
  `;font-size:13px;font-weight:600;line-height:16px;text-align:left;padding:2px 3px;border-radius:5px;transform:translate(2px,-2px);`
], cssVar["color-bg-primary-reverse"], cssVar["color-text-primary-reverse"]);

export { SelectPackage };
//# sourceMappingURL=SelectPackage.js.map
